// extracted by mini-css-extract-plugin
export default {"graphArea":"styles_graphArea__VCio0","rightPanel":"styles_rightPanel__VZx8h","closeGraph":"styles_closeGraph__tmjQL"};